import { render } from "./MainPageNavigation.vue?vue&type=template&id=4d4dfd18&scoped=true"
import script from "./MainPageNavigation.vue?vue&type=script&lang=js"
export * from "./MainPageNavigation.vue?vue&type=script&lang=js"

import "./MainPageNavigation.vue?vue&type=style&index=0&id=4d4dfd18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4dfd18"]])

export default __exports__